import type { SVGProps } from "react";
export interface TruckFastIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TruckFastIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TruckFastIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m15.05 16.875.116.006a1.125 1.125 0 0 1 0 2.238l-.116.006H10a1.125 1.125 0 0 1 0-2.25zM20.875 15v-2.876H16.5a2.125 2.125 0 0 1-2.125-2.123V5a.875.875 0 0 0-.874-.875h-.626a1.125 1.125 0 0 1 0-2.25h.626a3.12 3.12 0 0 1 3.118 3h.84c1.02 0 1.975.498 2.56 1.333l2.36 3.372c.211.302.376.63.5.973l.014.038c.15.433.232.89.232 1.355V15a4.13 4.13 0 0 1-2.86 3.927l-.111.03a1.125 1.125 0 0 1-.579-2.171l.14-.052A1.88 1.88 0 0 0 20.874 15Zm-20 0v-1.008a1.125 1.125 0 0 1 2.25 0V15c0 .814.52 1.51 1.25 1.768a1.125 1.125 0 0 1-.75 2.123A4.13 4.13 0 0 1 .875 15m15.75-5.125h3.214l-1.664-2.376a.88.88 0 0 0-.716-.374h-.834z"
      />
      <path
        fill={color}
        d="M8.875 18a1.875 1.875 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0m10 .5a1.376 1.376 0 1 0-2.752 0 1.376 1.376 0 0 0 2.752 0M8 8.875l.116.005a1.126 1.126 0 0 1 0 2.239L8 11.124H2a1.125 1.125 0 0 1 0-2.25zm2-4 .115.006a1.125 1.125 0 0 1 0 2.239L10 7.125H2a1.125 1.125 0 0 1 0-2.25zm-1-4 .115.006a1.126 1.126 0 0 1 0 2.238L9 3.125H2a1.125 1.125 0 0 1 0-2.25zM21.125 18.5a3.626 3.626 0 1 1-7.252 0 3.626 3.626 0 0 1 7.252 0m-10-.5a4.125 4.125 0 1 1-8.251 0 4.125 4.125 0 0 1 8.25 0Z"
      />
    </svg>
  );
}
